import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "example-typescript" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  id: "example-title",
  class: "example-title"
}, "Typescript Example", -1)
const _hoisted_3 = { class: "upload" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { class: "example-btn" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Select files ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-up",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Start Upload ")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-stop",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Stop Upload ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "pt-5 source-code" }, [
  /*#__PURE__*/_createTextVNode(" Source code: "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/lian-yue/vue-upload-component/blob/master/docs/views/examples/Typescript.vue" }, "/docs/views/examples/Typescript.vue")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_upload = _resolveComponent("file-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.files, (file) => {
          return (_openBlock(), _createElementBlock("li", {
            key: file.id
          }, [
            _createElementVNode("span", null, _toDisplayString(file.name), 1),
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.$formatSize(file.size)), 1),
            _hoisted_5,
            (file.error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(file.error), 1))
              : (file.success)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "success"))
                : (file.active)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "active"))
                  : (!!file.error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(file.error), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10))
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_file_upload, {
          class: "btn btn-primary",
          "post-action": "/upload/post",
          extensions: "gif,jpg,jpeg,png,webp",
          accept: "image/png,image/gif,image/jpeg,image/webp",
          multiple: true,
          size: 1024 * 1024 * 10,
          modelValue: $setup.files,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.files) = $event)),
          onInputFilter: $setup.inputFilter,
          onInputFile: $setup.inputFile,
          ref: "upload"
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _hoisted_13
          ], undefined, true),
          _: 1
        }, 8, ["modelValue", "onInputFilter", "onInputFile"]),
        (!$setup.upload || !$setup.upload.active)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-success",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.upload.active = true), ["prevent"]))
            }, _hoisted_16))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.upload.active = false), ["prevent"]))
            }, _hoisted_19))
      ])
    ]),
    _hoisted_20
  ]))
}